export default __webpack_public_path__ + "static/media/icons8-guarantee-100.c57ab642.svg";